import { render, staticRenderFns } from "./PayrollAuditExport.vue?vue&type=template&id=b353b878"
import script from "./PayrollAuditExport.vue?vue&type=script&lang=js"
export * from "./PayrollAuditExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports